import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';


const styles = (theme) => ({
  root: {
    fontWeight: 'bold',
    color: theme.palette.secondary.main,
  },
  indicatorIcon: {
    fontSize: 12,
    marginRight: theme.spacing(0.5),
  },
  uncategorizedColor: {
    color: theme.palette.warning.main,
  },

});

const StatusIndicator = ({
  className,
  classes,
  value,
}) => {
  const isMeetingUncategorized = value === 'uncategorized';
  const indicatorText = isMeetingUncategorized ? 'Please categorize' : 'Held';
  const IndicatorIcon = isMeetingUncategorized ? ErrorIcon : CheckCircleIcon;
  return (
    <Box
      className={classNames(className, classes.root, {
        [classes.uncategorizedColor]: isMeetingUncategorized,
      })}
    >
      <IndicatorIcon className={classes.indicatorIcon} />
      {indicatorText}
    </Box>
  );
};

StatusIndicator.defaultProps = {
  className: '',
};

StatusIndicator.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  value: PropTypes.string.isRequired,
};

export default withStyles(styles)(StatusIndicator);
